import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_pr9eppffs4: FaireBrandEntity = {
  token: "b_pr9eppffs4",
  type: "brand",
  name: "Bubbo & Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/26ae814c6b5de558bb3273fb97ce0597a230d359beb5bb3e238a4bf1bc5335d3.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/34ae8bf271f4f192b94cda3b4ee08889fa07d25c2ecbe5fe2894c4c05b26bad8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/26ae814c6b5de558bb3273fb97ce0597a230d359beb5bb3e238a4bf1bc5335d3.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/34ae8bf271f4f192b94cda3b4ee08889fa07d25c2ecbe5fe2894c4c05b26bad8.jpeg",
  location: "Chantilly, VA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 14,
  isInsider: true,
  description:
    "Bubbo & Co. was created by a working mama who wanted to create products for every type of parent in mind - organic and soft materials for baby at affordable prices.\n\nBubbo & Co. is an online-only shop offering cozy and quality baby clothing/baby essentials.\n\nWe are a small, minority and woman-owned business and we exude BIG love and thought into every single product. All products are designed from Northern Virginia, USA and meticulously working with overseas manufacturers to ensure quality of every product. We carry limited quantities of inventory which helps ensure the quality of your product.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:19.270Z",
    importedBy: "entity-db-cli",
  },
};
